import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { VMS_Notification } from 'src/app/model/notification.model';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  model: VMS_Notification;
  today: any = new Date();
  minSDate: string = this.today.getFullYear() + '-' + (this.today.getMonth() + 1) + '-' + this.today.getDate();
  minEDate: string = this.minSDate;
  dataId: string;
  AttachmentName: string = '';
  UploadedAttachments: string = '';
  Remarks: string = '';
  files: any[] = [];
  FileUpload: any[] = [];
  UserName: string;

downloadBaseURL :string;

  constructor(private toastr: ToastrService, private notificationSer: NotificationService,
    private route: ActivatedRoute, private router: Router) {
      this.downloadBaseURL = this.notificationSer.GetDownloadBaseURL();
    this.model = new VMS_Notification();
    //this.model.BODY_CONTENT ="<b>Rakesh </b>";
    this.route.queryParams.subscribe(params => { this.dataId = params['id']; });
    console.log('dataID', Number(this.dataId));
   

  }



  ngOnInit() {
    let id = 1;
    this.UserName = sessionStorage.getItem("UserName");
    if (this.dataId != undefined && this.dataId != null && this.dataId != '' && Number(this.dataId) > 0) {
      this.GetNotification(Number(this.dataId));
    }
    //this.GetNotification(id);


    //(<HTMLInputElement>document.getElementById("START_DATE")).min =  today.getFullYear() +'-'+(today.getMonth()+1) +'-'+today.getDate();


  }
 
  finalUploadedFile:string='';

  GetNotification(id: number) {
    this.notificationSer.GetNotification(id).subscribe(
      res => {
        console.log(res);
        this.model = res.Data;
        this.finalUploadedFile = this.CheckAttachmentName(this.model.ATTACHMENTS);
      },
      error => {
        console.log(error);
      }
    );
  }


  SaveNotification(action) {
    console.log(this.model);
    
    if (this.model.BODY_CONTENT == null || this.model.BODY_CONTENT == undefined || this.model.BODY_CONTENT.toString() =='') {
      this.toastr.warning("Please Enter Message Content.", "Error");
      return;
    }

    if (this.model.START_DATE == null || this.model.START_DATE == undefined || this.model.START_DATE.toString() =='') {
      this.toastr.warning("Please Enter Start Date.", "Error");
      return;
    }
    else if (this.model.END_DATE == null || this.model.END_DATE == undefined || this.model.START_DATE.toString() =='') {
      this.toastr.warning("Please Enter End Date.", "Error");
      return;
    }
    else if (new Date(this.model.END_DATE) < new Date(this.model.START_DATE)) {
      this.toastr.warning("End Date should be greater than Start Date ", "Error");
      return;
    }

    this.model.BODY_CONTENT = (<HTMLDivElement>document.getElementById("editorBODY")).innerHTML;

    this.model.STATUS = action;
    this.model.REMARKS = this.Remarks;
    if(this.UploadedAttachments != '' && this.UploadedAttachments != undefined && this.UploadedAttachments != null)
    {
    this.model.ATTACHMENTS = this.UploadedAttachments;
    }
    this.model.CREATED_BY = this.model.MODIFIED_BY = this.UserName;

    console.log(this.model);

    

    this.notificationSer.SaveNotification(this.model).subscribe(
      res => {
        console.log(res);
        if (res.Status) {
          
          if(this.model.ID == 0)
          {
            this.toastr.success("Notification is created successfully.", "Success");
            this.model = new VMS_Notification();
            this.AttachmentName='';
            this.Remarks='';
          }
          else
          {
            this.GetNotification(this.model.ID);
            this.toastr.success("Notification is updated successfully.", "Success");
          }
        }
        else {
          this.toastr.warning(res.Message, "Error");
        }
      },
      error => {
        console.log(error);
      }
    );
  }

  UploadAttachments() {

    this.UploadedAttachments = '';

    if (this.FileUpload.length <= 0) { return; }

    let formdata = new FormData();
    formdata.append('AttachmentName', this.AttachmentName);
    for (var i = 0; i < this.FileUpload.length; i++) {
      formdata.append(this.FileUpload[i].name, this.FileUpload[i]);
    }

    this.notificationSer.UploadFiles(formdata).subscribe(
      res => {
        console.log(res);
        if (res.Status) {
          this.UploadedAttachments = res.Data;
          //alert(res.Data);
        }
        else {
          this.toastr.warning(res.Message, "Error");
        }
      },
      error => {
        console.log(error);
      }
    );
  }


  RemoveAttachment()
  {
    this.finalUploadedFile = '';
    this.model.ATTACHMENTS=null;
  }


  IsBold: boolean = false;
  BClicked() { this.IsBold = !this.IsBold; }
  IsItalic: boolean = false;
  IClicked() { this.IsItalic = !this.IsItalic; }
  IsUnderline: boolean = false;
  UClicked() { this.IsUnderline = !this.IsUnderline; }

  // ************ Change Events  ***********************

  ChangeStartDate(event) {

    this.model.END_DATE = null;
    this.model.START_DATE = event;
    if (this.model.START_DATE == null || this.model.START_DATE == undefined || this.model.START_DATE.toString() == '') {
      return;
    }

    let sDate = new Date(this.model.START_DATE);
    console.log(sDate);
    this.minEDate = sDate.getFullYear() + '-' + (sDate.getMonth() + 1) + '-' + sDate.getDate();

    //this.model.END_DATE = new Date(sDate.setMonth(sDate.getMonth() + 2));
  }


  uploadFile(event): void {
    this.FileUpload = [];
    var totalsize = 0;
    for (let index = 0; index < event.length; index++) {
      totalsize += event[index].size;
      //alert(totalsize);
    }

    if (totalsize > 5242880) {
      alert("File Size is more than 5 MB");
      (<HTMLInputElement>document.getElementById("fileinput")).value = '';
      return;
    }

    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      this.files.push({ name: element.name, DownloadFlag: false });
      this.FileUpload.push(event[index]);
    }

    console.log('files', this.files);
    console.log('FileUpload', this.FileUpload);
    if (this.FileUpload.length > 0)
      this.UploadAttachments();
  }

 

  CheckAttachmentName(attachName): string {

    if (attachName == '' || attachName == undefined || attachName == null) {
      return '';
    }
    else {
      let li = attachName.indexOf('.');
      let fname = attachName.substring(0, (li - 15));
      const pattern = /_/gi;
      const replacement = " ";
      return fname;
      // return fname.replace(pattern, replacement);
    }
  }

  PreviewClicked()
  {
    this.model.BODY_CONTENT = (<HTMLDivElement>document.getElementById("editorBODY")).innerHTML;
  }

}


